export default __webpack_public_path__ + "static/media/2872.50b36d04.png";